var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-col-12"},[_c('page-header',{attrs:{"title":"forms.timeline-predefinition.title","actions":_vm.pageActions}}),_c('ancestryline-data-table',{attrs:{"data-function":_vm.dataFunction,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }